import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl, FormGroup, FormBuilder, Validators, AbstractControl, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'link-creator',
  imports: [
    CommonModule,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  templateUrl: './link-creator.component.html',
})
export class LinkCreatorComponent implements OnInit, OnDestroy {

  public linkCreatorForm!: FormGroup;
  public existingLink: boolean = false;
  public linkUrl: string = '';

  @Output() resultlinkDetailEvent = new EventEmitter<{ linkUrl: string, linkName: string } | null>();

  public _linkDetails: { linkUrl: string, linkName: string } | null = null;
  @Input()
  set linkDetails(value: { linkUrl: string, linkName: string } | null) {
    this._linkDetails = value;
    this.updateLinkCreatorForm();
  }
  get linkDetails() {
    return this._linkDetails;
  }

  constructor(
    private formBuilder: FormBuilder
  ) { }

  public ngOnInit(): void {
    this.updateLinkCreatorForm();
  }

  get highlightSaveButton(){
    const newLinkUrl = this.linkCreatorForm.controls["linkUrl"].value;
    const newLinkName = this.linkCreatorForm.controls["linkName"].value;
    return this.isHttpLink(newLinkUrl) && newLinkUrl !== this._linkDetails.linkUrl || newLinkName !== this._linkDetails.linkName;
  }

  private updateLinkCreatorForm() {
    //at least an empty string
    this.linkUrl = '';

    if (this.linkDetails && typeof this.linkDetails.linkUrl === 'string') {
      if (this.isHttpLink(this.linkDetails.linkUrl.trim()) || (this.linkDetails.linkUrl.trim().length === 0 && this.isHttpLink(this.linkDetails.linkName.trim()))) {
        this.existingLink = this.isHttpLink(this.linkDetails.linkUrl.trim());
        this.linkUrl = this.existingLink ? this.linkDetails.linkUrl.trim() : this.linkDetails.linkName.trim();
      }
    }

    if (this.linkCreatorForm) {
      this.linkCreatorForm.reset();
      this.linkCreatorForm.markAsPristine();
      this.linkCreatorForm.markAsUntouched();
      Object.values(this.linkCreatorForm.controls).forEach(control => {
        control.markAsPristine();
        control.markAsUntouched();
      });
      this.linkCreatorForm.patchValue({ "linkUrl": this.linkUrl, "linkName": this.linkDetails.linkName ? this.linkDetails.linkName.trim() : '' })
    } else {
      this.linkCreatorForm = this.formBuilder.group({
        linkUrl: new FormControl(this.linkUrl, [Validators.required, (control: AbstractControl) => { return this.isHttpLink(control.value) ? null : { 'incorrect': true } }]),
        linkName: new FormControl(this.linkDetails.linkName ? this.linkDetails.linkName.trim() : ''),
      });
    }
  }

  public ngOnDestroy(): void {
  }

  public close(save: boolean) {
    if (save) {

      if (this.linkCreatorForm.invalid) {
        this.linkCreatorForm.controls['linkUrl'].markAsTouched();
        this.linkCreatorForm.controls['linkUrl'].markAsDirty();
        return;
      }

      const result = { linkUrl: "", linkName: "" };

      let updatedlinkUrl = this.linkCreatorForm.value['linkUrl'].trim();
      updatedlinkUrl = this.isHttpLink(updatedlinkUrl) ? updatedlinkUrl : '';
      let updatedLinkName = this.linkCreatorForm.value['linkName'].trim();
      //no link text filled in yet? auto fill
      updatedLinkName = updatedlinkUrl && !updatedLinkName ? updatedlinkUrl : updatedLinkName;

      if (updatedlinkUrl && updatedLinkName) {
        result.linkUrl = updatedlinkUrl
        result.linkName = updatedLinkName;
      }

      this.resultlinkDetailEvent.emit(result);

    } else {
      this.resultlinkDetailEvent.emit(null);
    }
  }

  public removeLink() {
    this.resultlinkDetailEvent.emit({ linkUrl: 'remove_link', linkName: '' });
  }

  private isHttpLink(link: string) {
    // if ("parse" in URL) {
    //   //return URL.parse(link) !== null;
    //   return link ? /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}/.test('' + URL.parse(link)) : false;
    // } else {
    try {
      return link ? /^http(s)?:\/\/.+$/.test(link) : false;
    } catch (e) {
      return false;
    }
    // }
  }
}